import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../../helpers/spinner";
import helperNumbers from "../../../../../helpers/numbers";
import helperTime from "../../../../../helpers/time";
import Pagination from "../../../../partials/content/Pagination";

export default function AllLogEditGift() {
  const [allLogEditGift, setAllLogEditGift] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  const params = useParams();
  const giftID = params.giftID;

  useEffect(() => {
    getAllLogEditGift();
  }, [currentPage, countItemPerPage]);

  const getAllLogEditGift = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestGetAllLogEditGift =
      await sendRequestGetAllLogEditGift();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestGetAllLogEditGift) {
      return;
    }
    setAllLogEditGift(resultSendRequestGetAllLogEditGift.edit_logs);
    setCountPage(resultSendRequestGetAllLogEditGift.count_page);
  };

  const sendRequestGetAllLogEditGift = async () => {
    let headersRequest = getHeaderForRequest();
    let allGifts;
    try {
      allGifts = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/gift/manage/all-log-edit/${giftID}?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allGifts.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateTable = () => {
    return (
      <div>
        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره لاگ</td>
                <td>حداقل مقدار قبل</td>
                <td>حداقل مقدار بعد</td>
                <td>حداکثر مقدار قبل</td>
                <td>حداکثر مقدار بعد</td>
                <td>تارخ تغییر</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allLogEditGift.map((logEditGift, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{logEditGift.log_id}</td>
                    <td className="number-finance">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(
                          logEditGift.log_min_amount_before
                        )
                      )}
                    </td>
                    <td className="number-finance">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(
                          logEditGift.log_min_amount_after
                        )
                      )}
                    </td>
                    <td className="number-finance">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(
                          logEditGift.log_max_amount_before
                        )
                      )}{" "}
                    </td>
                    <td className="number-finance">
                      {helperNumbers.toPersianNum(
                        helperNumbers.toFormatFinanceNumber(
                          logEditGift.log_max_amount_after
                        )
                      )}
                    </td>
                    <td>
                      {helperNumbers.toPersianNum(
                        helperTime.convertGregorianToJalali(
                          logEditGift.log_created_at
                        ) +
                          " " +
                          logEditGift.log_created_at.split(" ")[1]
                      )}
                    </td>
                    <td>
                      <span className="px-2">
                        <Link
                          to={`/finance/manage/gift/log/view/${logEditGift.log_id}`}
                          className="btn btn-info"
                        >
                          <i className="fa fa-info"></i>
                        </Link>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 && generatePagination()}
      </div>
    );
  };

  return (
    <>
      <Sidebar />
      <div className="content-wrapper">
        <section className="content-header pt-4 pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1 bg-warning">لیست تغییرات هدیه</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link to="/finance/manage/all-gift" className="btn btn-primary">
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {allLogEditGift.length > 0 && generateTable()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
